export default __webpack_public_path__ + "static/media/G0440-ICD_algorithm_.1702485300000.3b0d9dac.jpg";